import React from 'react';
type PricingOption = {
  title: string;
  format: string;
  price: string;
  description: string;
  features: string[];
  popular?: boolean;
  image?: string;
  originalPrice?: string;
  savingsText?: string;
  link: string; // 🔥 LINK SHOPIFY
};
/* =========================
      OPCIONES DIGITALES
   ========================= */
const digitalOptions: PricingOption[] = [{
  title: 'Audio Devocional',
  format: 'MP3',
  price: '$12',
  description: 'El audio devocional completo en formato MP3 para escucharlo en cualquier momento y lugar.',
  features: ['Audio devocional completo en MP3', 'Perfecto para escuchar en el celular, auto o caminando', 'Acceso inmediato después de la compra', 'Acceso de por vida'],
  image: 'https://i.postimg.cc/kM6kQ4JF/audio_ebook_nuevo.png',
  link: 'https://pay.hotmart.com/N103742584A'
}, {
  title: 'Bundle Completo Premium',
  format: 'PDF + MP3 + Bonos',
  price: '$19',
  originalPrice: '$68',
  savingsText: 'Ahorras $49 hoy',
  description: 'La experiencia completa: ebook, audio y contenido extra exclusivo para fortalecer tu fe día a día.',
  features: ['Ebook completo en PDF (descarga inmediata)', 'Audio devocional completo en MP3', 'Acceso de por vida a todo el contenido', 'Actualizaciones futuras GRATIS', 'BONO #1: "Guía de Oraciones que Sanan el Alma"', 'BONO #2: "Rutinas Espirituales de 5 Minutos para Días Difíciles"'],
  popular: true,
  image: 'https://i.postimg.cc/4d5btpKy/budle-primium-nuevo.png',
  link: 'https://pay.hotmart.com/J103766139T'
}];
/* =========================
       COMPONENTE
   ========================= */
export function PricingSection() {
  return <section id="pricing" className="section-card bg-slate-950 text-white" data-id="element-104">
      <div className="max-w-6xl mx-auto px-4 py-16" data-id="element-105">
        <div className="text-center mb-10" data-id="element-106">
          <h2 className="text-3xl md:text-4xl font-bold" data-id="element-107">Elige Tu Formato</h2>
          <p className="mt-3 text-slate-300" data-id="element-108">
            Todas las opciones incluyen el contenido completo de los 30 días.
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2 max-w-4xl mx-auto" data-id="element-109">
          {digitalOptions.map(option => <div key={option.title} className={`relative rounded-3xl border border-slate-700/80 bg-gradient-to-b from-slate-900 to-slate-950 p-7 md:p-8 shadow-xl ${option.popular ? 'ring-2 ring-yellow-400/80 md:scale-[1.03]' : ''}`} data-id="element-110">
              {option.popular && <span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-yellow-400 px-4 py-1 text-xs font-bold text-slate-900" data-id="element-111">
                  MÁS POPULAR
                </span>}

              {option.image && <div className="mb-5 flex justify-center" data-id="element-112">
                  <img src={option.image} alt={option.title} className="h-40 w-auto drop-shadow-xl" data-id="element-113" />
                </div>}

              <p className="text-xs font-semibold uppercase tracking-[0.25em] text-slate-300" data-id="element-114">
                {option.format}
              </p>

              <h4 className="mt-1 text-2xl font-semibold" data-id="element-115">{option.title}</h4>

              <div className="mt-4 flex items-baseline gap-2" data-id="element-116">
                {option.originalPrice && <span className="text-lg text-slate-400 line-through" data-id="element-117">
                    {option.originalPrice}
                  </span>}
                <span className="text-4xl font-extrabold text-yellow-300" data-id="element-118">
                  {option.price}
                </span>
              </div>

              {option.savingsText && <p className="mt-1 text-sm font-semibold text-emerald-400" data-id="element-119">
                  {option.savingsText}
                </p>}

              <p className="mt-4 text-sm text-slate-200" data-id="element-120">
                {option.description}
              </p>

              <ul className="mt-4 space-y-2 text-sm text-slate-100" data-id="element-121">
                {option.features.map(feature => <li key={feature} className="flex gap-2" data-id="element-122">
                    <span className="mt-1 h-1.5 w-1.5 rounded-full bg-yellow-400" data-id="element-123" />
                    <span data-id="element-124">{feature}</span>
                  </li>)}
              </ul>

              {/* BOTÓN CON LINK SHOPIFY */}
              <a href={option.link} className="mt-6 block w-full rounded-full bg-yellow-400 py-3 text-center text-sm font-semibold text-slate-900 transition hover:bg-yellow-300" data-id="element-125">
                ELEGIR ESTE FORMATO
              </a>
            </div>)}
        </div>
      </div>
    </section>;
}